/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2021-12-23 18:40:38
 * @LastEditors: geory
 * @LastEditTime: 2026-04-24 15:15:46
 */
var a = navigator.userAgent.toLowerCase();
let config = {
  ipad: /ipad/.test(a),
  iphone: /iphone/.test(a),
  android: /android/.test(a),
  weixin: /micromessenger/.test(a),
  isQQApp: a.match(/QQ/i) == "qq",
  iosScheme: "wssyxj://edujia.com/",
  androidPackageName: "com.dingYZ.dingyzwater",
  downloadUrl: "http://www.edujia.com/",
  ak: "0a02040602050504",
  localDataVersion: "1.0.2",
  app: "wminputManager", // wminputWeb 输入法pc端 wminputManager 输入法话术管理后台
};
export default config;
